import { DefaultService } from "@/api/SolarCloudApi";
import { QueryConfig } from "@/lib/react-query";
import { queryOptions, useQuery } from "@tanstack/react-query";

export default function getEnergyCompaniesQueryOptions() {
  return queryOptions({
    queryKey: ["energyCompanies"],
    queryFn: getEnergyCompanies,
    staleTime: 1000 * 60 * 60 * 24, // 24 hours
  });
}

async function getEnergyCompanies() {
  const response = await DefaultService.getActiveEnergyCompanies();
  return response?.collection ?? [];
}

type useEnergyCompaniesOptions = {
  queryConfig?: QueryConfig<typeof getEnergyCompaniesQueryOptions>;
};

export function useEnergyCompanies({
  queryConfig,
}: useEnergyCompaniesOptions = {}) {
  return useQuery({
    ...getEnergyCompaniesQueryOptions(),
    ...queryConfig,
  });
}
